import React from "react";
import { useCart } from "hooks/useStore";
import { ReactComponent as InfoIcon } from "assets/svgs/info-bronze.svg";
import useToggle from "hooks/useToggle";
import WarrantyModal from "components/warranty-modal";
import Loader from "components/loader";
import { trackAddToCartWarranty } from "analytics";

const WarrantyUpsell = ({ product, warrantyProducts = [] }) => {
	const { addCartItem, items } = useCart(["addCartItem", "items"]);
	const [isModalOpen, toggleModal] = useToggle();
	const [isLoading, toggleLoading] = useToggle();

	const warrantyGid = product.attributes?.find(attr => attr.key === "_warranty")?.value;
	const warrantyProduct = warrantyProducts.find(({ variant }) => variant.gid === warrantyGid);
	const isAlreadyInCart = items.some(item => item.id === warrantyProduct?.id);
	const activeWarranty = warrantyProduct?.status === "active" && warrantyProduct?.variant?.isAvailable;

	if (!warrantyProduct || isAlreadyInCart || !activeWarranty) return null;

	const handleAddToCart = async () => {
		if (!warrantyGid) return;
		toggleLoading();
		await addCartItem(warrantyGid, 1);
		trackAddToCartWarranty(warrantyProduct);
		toggleLoading();
	};

	return (
		<>
			<WarrantyModal product={warrantyProduct} isOpen={isModalOpen} toggleModal={toggleModal} />
			<div className="flex flex-wrap gap-2 px-4 py-2.5 bg-beige/15 warranty-upsell">
				<div className="flex w-full justify-between">
					<div className="flex items-center">
						<span className="text-sm font-semibold text-deepBronze">
							Add 2-Year Extended Warranty
						</span>
						<button onClick={toggleModal} className="p-1.5">
							<InfoIcon />
						</button>
					</div>
					<button onClick={handleAddToCart} className="text-deepBronze text-sm underline underline-offset-2" >
						{isLoading ? <Loader /> : "Add"}
					</button>
				</div>
			</div>
		</>
	);
};

export default WarrantyUpsell;
